<template>
  <default-modal
    v-model="modalOpened"
    name="authorization-dialog"
    :title="title"
    :autofocus="$refs.password"
    @hide="cancel"
  >
    <template slot="content">
      <p>{{ message }}</p>

      <form id="authorization-dialog" @submit.prevent="handleAuthorize">
        <q-field
          :error="errors.has('auth-dialog__password')"
          :error-label="errors.first('auth-dialog__password')"
        >
          <q-input
            v-model="password"
            type="password"
            ref="password"
            :float-label="$t('password')"
            name="auth-dialog__password"
            v-validate.disable="'required'"
            :data-vv-as="$t('password')"
            autocomplete="current-password"
            required
            @keydown.enter="handleAuthorize"
          />
        </q-field>
      </form>
    </template>

    <template slot="footer">
      <q-btn @click="handleAuthorize" color="positive">
        {{ $t('authorize') }}
      </q-btn>
    </template>
  </default-modal>
</template>

<script>
  import DefaultModal from 'components/Modal/DefaultModal.vue'
  import i18n from 'src/i18n/i18n'

  export default {
    $_veeValidate: {
      validator: 'new'
    },

    props: {
      title: {
        type: String,
        default: i18n.t('authorize')
      },
      message: {
        type: String,
        default: i18n.t('authorization_required')
      }
    },

    data () {
      return {
        modalOpened: false,
        resolve: null,
        reject: null,
        password: '',
        submitted: false
      }
    },

    methods: {
      open () {
        return new Promise((resolve, reject) => {
          this.resolve = resolve
          this.reject = reject
          this.submitted = false

          this.modalOpened = true
        })
      },

      handleAuthorize () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) {
              return
            }

            this.submitted = true
            this.modalOpened = false

            this.resolve(this.password)
            this.password = null
          })
      },

      cancel () {
        if (!this.submitted) {
          this.modalOpened = false
          this.password = null
          this.reject('cancel')
        }
      }
    },

    components: {
      DefaultModal
    }
  }
</script>
